(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["abc-product-card"] && !Shopify.designMode) return;
  try {
    (function () {
  document.querySelectorAll('.nrh-card__variant-select').forEach(function (select) {
    select.addEventListener('change', function () {
      var card  = this.closest('.nrh-card');
      var btn   = card.querySelector('.nrh-card__atc');
      var opt   = this.options[this.selectedIndex];
      var price = opt.getAttribute('data-price');

      btn.dataset.variantId = this.value;
      btn.textContent = 'Add to cart — ' + price;
      btn.setAttribute('aria-label', 'Add ' + card.querySelector('.nrh-card__title').textContent.trim() + ' to cart');

      var priceEl      = card.querySelector('.nrh-card__price');
      var origEl       = card.querySelector('.nrh-card__orig');
      var savingsEl    = card.querySelector('.nrh-card__savings');
      var comparePrice = opt.getAttribute('data-compare-price');
      var savings      = opt.getAttribute('data-savings');

      if (priceEl) priceEl.textContent = price;

      if (comparePrice) {
        if (origEl)    { origEl.textContent    = comparePrice; origEl.style.display    = ''; }
        if (savingsEl) { savingsEl.textContent = 'Save ' + savings; savingsEl.style.display = ''; }
      } else {
        if (origEl)    origEl.style.display    = 'none';
        if (savingsEl) savingsEl.style.display = 'none';
      }
    });
  });

  document.querySelectorAll('.nrh-card__atc[data-variant-id]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var card = btn.closest('.nrh-card');
      var orig = btn.textContent.trim();
      btn.textContent = 'Adding…';
      btn.classList.add('nrh-card__atc--loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: btn.dataset.variantId, quantity: 1 })
      })
      .then(function (r) { return r.json(); })
      .then(function () {
        btn.textContent = 'Added ✓';
        var statusEl = card.querySelector('[data-nrh-status]');
        if (statusEl) statusEl.textContent = 'Added to cart';
        return fetch('/cart.js');
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count], .abc-cart-count, #abc-cart-count, #abc-float-cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        var floatBtn = document.getElementById('abc-float-cart');
        if (floatBtn && cart.item_count > 0) floatBtn.classList.remove('is-empty');
        document.dispatchEvent(new CustomEvent('cart:updated'));
        setTimeout(function () {
          btn.textContent = orig;
          btn.classList.remove('nrh-card__atc--loading');
          var statusEl = card.querySelector('[data-nrh-status]');
          if (statusEl) statusEl.textContent = '';
        }, 2200);
      })
      .catch(function () {
        btn.textContent = 'Error — try again';
        btn.classList.remove('nrh-card__atc--loading');
        setTimeout(function () { btn.textContent = orig; }, 2500);
      });
    });
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["magazine-header"] && !Shopify.designMode) return;
  try {
    class MagazinePage extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('[data-theme-toggle]');
      // Initial theme is applied before paint by the inline data-apx-theme-init
      // script (saved choice, else OS preference). Just reflect it on the toggle.
      var isLight = this.classList.contains('is-light');
      if (this.toggle) {
        this.toggle.textContent = isLight ? 'Dark' : 'Light';
        this.toggle.setAttribute('aria-pressed', String(isLight));
        this.toggle.addEventListener('click', () => this.setLight(!this.classList.contains('is-light')));
      }
      this.tagMagazineLinks();
    }
    // Keep in-magazine navigation inside the dark sub-brand: append ?view= to
    // apex-magazine article links so they render the magazine reader (and carry
    // the saved theme) instead of falling back to the default article template.
    tagMagazineLinks() {
      var links = this.querySelectorAll('a[href^="/blogs/apex-magazine/"]');
      for (var i = 0; i < links.length; i++) {
        var href = links[i].getAttribute('href');
        if (!href || href.indexOf('view=') !== -1) continue;
        var slug = href.split('?')[0].split('#')[0].replace('/blogs/apex-magazine/', '');
        if (!slug || slug.indexOf('/') !== -1) continue; // skip blog index, /tagged/, etc.
        var view = /^issue-\d+$/.test(slug) ? 'apex-magazine-issue' : 'apex-magazine';
        links[i].setAttribute('href', href + (href.indexOf('?') === -1 ? '?' : '&') + 'view=' + view);
      }
    }
    setLight(on) {
      this.classList.toggle('is-light', on);
      // Reflect state on <html> so siblings (e.g. the shared footer) can react
      document.documentElement.classList.toggle('apx-mag-light', on);
      if (this.toggle) {
        this.toggle.textContent = on ? 'Dark' : 'Light';
        this.toggle.setAttribute('aria-pressed', String(on));
      }
      try { localStorage.setItem('apx-theme', on ? 'light' : 'dark'); } catch (e) {}
    }
  }
  if (!customElements.get('magazine-page')) customElements.define('magazine-page', MagazinePage);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["magazine-kickstarter"] && !Shopify.designMode) return;
  try {
    (function () {
    function update() {
      document.querySelectorAll('[data-ks-launch]').forEach(function (root) {
        var launch = parseInt(root.getAttribute('data-ks-launch'), 10) * 1000;
        var live = launch > 0 && Date.now() >= launch;
        root.querySelectorAll('[data-ks-state]').forEach(function (el) {
          el.hidden = (el.getAttribute('data-ks-state') === 'live') !== live;
        });
      });
    }
    update();
    setInterval(update, 30000);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["reading-controls"] && !Shopify.designMode) return;
  try {
    class ReadingControls extends HTMLElement {
    connectedCallback() {
      this.valEl = this.querySelector('[data-fs-val]');
      this.fontBtn = this.querySelector('[data-font-toggle]');
      this.scale = 1;
      try { var s = parseFloat(localStorage.getItem('apx-fontscale')); if (s >= 0.85 && s <= 1.4) this.scale = s; } catch (e) {}
      this.applyScale();
      var dec = this.querySelector('[data-fs-dec]');
      var inc = this.querySelector('[data-fs-inc]');
      if (dec) dec.addEventListener('click', () => this.step(-0.1));
      if (inc) inc.addEventListener('click', () => this.step(0.1));
      var hl = false;
      try { hl = localStorage.getItem('apx-readfont') === 'hyperlegible'; } catch (e) {}
      this.setFont(hl);
      if (this.fontBtn) this.fontBtn.addEventListener('click', () => this.setFont(!this.root() || !this.root().classList.contains('is-hl')));
    }
    root() { return this.closest('[data-reader-root]'); }
    step(d) { this.scale = Math.max(0.85, Math.min(1.4, Math.round((this.scale + d) * 100) / 100)); this.applyScale(); try { localStorage.setItem('apx-fontscale', String(this.scale)); } catch (e) {} }
    applyScale() { var r = this.root(); if (r) r.style.setProperty('--reader-scale', this.scale); if (this.valEl) this.valEl.textContent = Math.round(this.scale * 100) + '%'; }
    setFont(on) {
      var r = this.root(); if (r) r.classList.toggle('is-hl', on);
      if (this.fontBtn) { this.fontBtn.setAttribute('aria-pressed', String(on)); this.fontBtn.textContent = on ? 'Standard' : 'Hyperlegible'; }
      try { localStorage.setItem('apx-readfont', on ? 'hyperlegible' : 'default'); } catch (e) {}
    }
  }
  if (!customElements.get('reading-controls')) customElements.define('reading-controls', ReadingControls);
  } catch(e) { console.error(e); }
})();

})();
